import { ProcessCellForExportParams, GridApi } from 'ag-grid-community'
import { useCallback } from 'react'
import { exportExcel } from '../../../containers/BulkSheet/excel'
import { formatDateForApi } from '../../../../utils/date'
import { useDialogState } from '../../../components/dialogs/useDialogState'

export const useExcel = (gridApi: GridApi | undefined) => {
  const [dialogOpen, openDialog, closeDialog] = useDialogState()

  const customExportValues = useCallback(
    (params: ProcessCellForExportParams) => {
      if (!params.node) return undefined
      const columnId: string = params.column.getColId()
      const row = params.node.data

      if (columnId === 'rowNumber') {
        return (params?.node?.rowIndex ?? 0) + 1
      }

      if (columnId === 'projectName') {
        return row?.projectName ?? ''
      }

      if (columnId === 'projectStatus') {
        return row?.projectStatus ?? ''
      }

      if (columnId === 'closingStatus') {
        return row?.closingStatus ?? ''
      }

      if (
        columnId === 'startDate' ||
        columnId === 'endDate' ||
        columnId === 'closingDate'
      ) {
        return formatDateForApi(params.value) || ''
      }

      if (typeof params.value === 'object' && params.value !== null) {
        return params.value.name ?? params.value.displayName ?? ''
      }

      return undefined
    },
    []
  )

  const onExportExcel = useCallback(
    (colIds: string[]) => {
      if (!colIds || colIds.length === 0 || !gridApi) return

      exportExcel({
        fileNamePrefix: 'project_closing_status',
        gridApi,
        exportColIds: colIds,
        getCustomExportValue: customExportValues,
        shouldRowBeSkipped: params =>
          !params.node.data || !params.node.displayed,
      })
      closeDialog()
    },
    [gridApi, customExportValues, closeDialog]
  )

  return {
    dialogOpen,
    openDialog,
    closeDialog,
    onExportExcel,
  }
}
